// extracted by mini-css-extract-plugin
export default {"wrap":"index_wrap_kphF6","content":"index_content_9KUT-","textPrefix":"index_textPrefix_sEhQo"};